const downloadPageReg = /^(\/download%23)/

export default (path) => {
  if (downloadPageReg.test(path)) {
    let url = ''
    try {
      url = decodeURIComponent(path)
    } catch {
      url = '/download'
      console.error('下载路径转换失败')
    }

    return url
  }
}
